export const cases = [
  {
    id: "mcn-contract-split",
    title: "千万粉博主解约风波：从“被雪藏”到双方各执一词",
    handle: "@老潼关的深夜食堂",
    category: "经纪解约",
    status: "事件反转",
    reversal: 3,
    follow: 18,
    updatedAt: "2026-09-08",
    readTime: "6 分钟",
    summary:
      "一纸解约声明把账号归属、分成比例和“雪藏”传闻一起推上台面。随着合同片段流出，原本单向的指责说法出现反转。",
    cover: "https://readdy.ai/api/search-image?query=Torn%20paper%20contract%20halves%20resting%20on%20a%20dark%20walnut%20desk%20beside%20a%20wax%20sealed%20envelope%20and%20a%20brass%20pen%2C%20warm%20amber%20and%20deep%20crimson%20editorial%20lighting%2C%20dark%20textured%20paper%20backdrop%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%2C%20moody%20magazine%20still%20life%2C%20no%20text%2C%20no%20watermark%2C%20cohesive%20muted%20warm%20palette&width=1200&height=800&seq=gtk-case-01&orientation=landscape",
    tags: ["账号归属", "分成争议", "合同片段", "双方声明"],
    timeline: [
      { date: "2026-08-21", type: "爆料", title: "博主单方面发布解约声明", desc: "账号在凌晨发布长图，称合作三年间“内容方向被反复干预”，并暗示账号一度被限制更新。" },
      { date: "2026-08-27", type: "回应", title: "经纪公司首次回应", desc: "公司发布说明，否认“雪藏”说法，表示更新的暂停源于双方对选题分歧的正常协商。" },
      { date: "2026-09-01", type: "反转", title: "疑似合同片段流出", desc: "有从业者晒出分割截图，显示账号注册主体为个人，合作模式更接近“内容代运营”而非全约经纪。" },
      { date: "2026-09-04", type: "辟谣", title: "关于“封杀”的传闻被澄清", desc: "平台运营人员私下确认，账号并未收到任何限流或封禁通知，更新为博主主动暂停。" },
      { date: "2026-09-08", type: "官方", title: "双方同意进入协商流程", desc: "目前双方均未公布最终结果，账号是否复更、历史内容归谁，仍待后续说明。" },
    ],
    statements: [
      { who: "@老潼关的深夜食堂", role: "当事博主", text: "我需要的不是同情，是把合作关系讲清楚。更新暂停是我的选择，不是被封。" },
      { who: "某内容公司负责人", role: "第一方回应", text: "所谓“雪藏”没有依据。我们希望在协商中解决，而不是在舆论场上互相消耗。" },
      { who: "行业观察者 阿黎", role: "第三方分析", text: "这类纠纷的关键往往不在情绪，而在账号主体的注册信息和分成条款的书面证据。" },
    ],
    related: ["live-sell-price", "copy-script"],
  },
  {
    id: "live-sell-price",
    title: "直播间“全网最低价”被质疑：比价截图流出后当场关播",
    handle: "@柠七选好物",
    category: "直播带货",
    status: "持续追踪",
    reversal: 2,
    follow: 24,
    updatedAt: "2026-09-07",
    readTime: "5 分钟",
    summary:
      "“全网最低”的口号遇上第三方比价截图，当场关播的举动又让质疑升级。选品团队随后给出进货单，但争议仍未平息。",
    cover: "https://readdy.ai/api/search-image?query=Vintage%20price%20tag%20and%20a%20magnifying%20glass%20resting%20over%20scattered%20receipts%20on%20a%20textured%20dark%20surface%2C%20warm%20amber%20and%20deep%20crimson%20editorial%20lighting%2C%20dark%20textured%20paper%20backdrop%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%2C%20moody%20magazine%20still%20life%2C%20no%20text%2C%20no%20watermark%2C%20cohesive%20muted%20warm%20palette&width=1200&height=800&seq=gtk-case-02&orientation=landscape",
    tags: ["比价", "全网最低", "进货单", "关播"],
    timeline: [
      { date: "2026-08-30", type: "爆料", title: "观众晒出同款比价截图", desc: "有观众在弹幕指出同款商品在其他渠道便宜近三成，直播间的“全网最低价”说法受到质疑。" },
      { date: "2026-08-30", type: "回应", title: "主播现场关播", desc: "主播回应称“系统价格没同步”，随后中断直播，这一举动被解读为“心虚”而被大量讨论。" },
      { date: "2026-09-03", type: "反转", title: "选品团队公布进货单", desc: "团队出示了采购与物流成本明细，解释价差来自赠品与售后服务的差异，而非单纯抬价。" },
      { date: "2026-09-07", type: "官方", title: "平台介入核查话术", desc: "平台表示会核查“全网最低”这类绝对化用词是否违反宣传规范，结论尚未公布。" },
    ],
    statements: [
      { who: "@柠七选好物", role: "当事主播", text: "我承认“全网最低”这句话说得太满，愿意改成“我会争取的机制价”。" },
      { who: "选品经理 大斌", role: "第一方回应", text: "成本结构可以公开，但希望别用一张截图就给整场直播定性。" },
    ],
    related: ["data-traffic", "brand-collab-fail"],
  },
  {
    id: "copy-script",
    title: "新锐账号被指“洗稿”同赛道博主：脚本逐帧对比流出",
    handle: "@半格生活研究所",
    category: "内容版权",
    status: "待核实",
    reversal: 1,
    follow: 11,
    updatedAt: "2026-09-05",
    readTime: "4 分钟",
    summary:
      "两个账号的选题、结构甚至转场镜头高度相似。是被指“洗稿”，还是同题材下的正常巧合，双方各有说法。",
    cover: "https://readdy.ai/api/search-image?query=Two%20identical%20stacks%20of%20printed%20manuscripts%20side%20by%20side%20casting%20overlapping%20shadows%20on%20a%20warm%20wooden%20table%2C%20warm%20amber%20and%20deep%20crimson%20editorial%20lighting%2C%20dark%20textured%20paper%20backdrop%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%2C%20moody%20magazine%20still%20life%2C%20no%20text%2C%20no%20watermark%2C%20cohesive%20muted%20warm%20palette&width=1200&height=800&seq=gtk-case-03&orientation=landscape",
    tags: ["洗稿", "脚本对比", "选题重合", "版权"],
    timeline: [
      { date: "2026-08-24", type: "爆料", title: "原作博主放出对比视频", desc: "原作将两条视频并排对比，指出分镜节奏与文案结构“几乎逐句对应”。" },
      { date: "2026-08-26", type: "回应", title: "被指账号回应“巧合”", desc: "对方表示二人长期关注同一类选题，风格接近属行业常态，并称未接触过原作脚本。" },
      { date: "2026-09-05", type: "官方", title: "平台暂未认定侵权", desc: "平台表示“洗稿”认定需要更充分证据，目前双方仍在沟通，事件暂无定性。" },
    ],
    statements: [
      { who: "@半格生活研究所", role: "被指账号", text: "同赛道做久了，镜头语言会互相趋同。我欢迎对比，但不接受“洗稿”这个标签。" },
      { who: "@拾光慢放", role: "原作博主", text: "我不想吵，只希望引用结构的时候能标注来源，这对原创者是基本的尊重。" },
    ],
    related: ["mcn-contract-split", "data-traffic"],
  },
  {
    id: "pet-charity",
    title: "萌宠博主“救助金”去向存疑：账目公开后质疑声渐平",
    handle: "@橘座的收容日记",
    category: "公益争议",
    status: "已澄清",
    reversal: 2,
    follow: 15,
    updatedAt: "2026-09-02",
    readTime: "5 分钟",
    summary:
      "一场救助直播筹得的善款被质疑用途不明。面对追问，博主公开了完整收支明细，质疑声随之降温。",
    cover: "https://readdy.ai/api/search-image?query=Small%20donation%20jar%20with%20coins%20beside%20a%20folded%20handwritten%20ledger%20on%20a%20warm%20wooden%20table%2C%20warm%20amber%20and%20deep%20crimson%20editorial%20lighting%2C%20dark%20textured%20paper%20backdrop%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%2C%20moody%20magazine%20still%20life%2C%20no%20text%2C%20no%20watermark%2C%20cohesive%20muted%20warm%20palette&width=1200&height=800&seq=gtk-case-04&orientation=landscape",
    tags: ["善款", "收支明细", "救助直播", "澄清"],
    timeline: [
      { date: "2026-08-15", type: "爆料", title: "评论区质疑善款用途", desc: "有粉丝追问救助直播所得的去向，希望看到医院单据与收支明细。" },
      { date: "2026-08-19", type: "回应", title: "博主公开第一批凭证", desc: "博主发布治疗费用清单，但被指出缺少部分转账记录，质疑并未停止。" },
      { date: "2026-08-28", type: "辟谣", title: "关于“私吞善款”的说法被澄清", desc: "第三方志愿者核实后表示，剩余款项已转入合作机构账户，用于后续安置。" },
      { date: "2026-09-02", type: "官方", title: "完整账目公示，事件平息", desc: "博主补齐全部明细并承诺按季度公示，相关质疑基本平息。" },
    ],
    statements: [
      { who: "@橘座的收容日记", role: "当事博主", text: "我理解大家的不安，所以把每一笔都摆出来。以后按季度公示，不用大家来追问。" },
      { who: "志愿者 小满", role: "第三方核实", text: "我核对了银行流水与机构回执，目前看到的账目是对得上的。" },
    ],
    related: ["live-sell-price", "fake-romance-script"],
  },
  {
    id: "brand-collab-fail",
    title: "品牌联名翻车：设计师回应“并非抄袭”，联名方连夜下架",
    handle: "@拾贰青年×某服饰品牌",
    category: "品牌联动",
    status: "暂无后续",
    reversal: 1,
    follow: 9,
    updatedAt: "2026-08-29",
    readTime: "4 分钟",
    summary:
      "联名系列上线一天就被指图案与独立设计师作品高度相似。品牌连夜下架，插画师则发长文自证创作过程。",
    cover: "https://readdy.ai/api/search-image?query=Crumpled%20designer%20sketch%20and%20a%20rolled%20fabric%20swatch%20on%20a%20studio%20table%20beside%20colored%20pencils%2C%20warm%20amber%20and%20deep%20crimson%20editorial%20lighting%2C%20dark%20textured%20paper%20backdrop%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%2C%20moody%20magazine%20still%20life%2C%20no%20text%2C%20no%20watermark%2C%20cohesive%20muted%20warm%20palette&width=1200&height=800&seq=gtk-case-05&orientation=landscape",
    tags: ["联名", "图案相似", "下架", "创作过程"],
    timeline: [
      { date: "2026-08-12", type: "爆料", title: "网友指出图案高度相似", desc: "有网友将联名图案与一位独立插画师旧作并列，指出配色与构图“几乎重合”。" },
      { date: "2026-08-12", type: "官方", title: "品牌连夜下架该系列", desc: "品牌在数小时内下架相关商品并致歉，表示会先厘清设计来源。" },
      { date: "2026-08-20", type: "回应", title: "插画师发布创作时间线", desc: "联名方插画师晒出草稿与修改记录，称独立完成，并否认接触过被指作品。" },
      { date: "2026-08-29", type: "官方", title: "事件暂无进一步进展", desc: "双方均未再公开表态，是否重新上架或走法律程序没有新消息。" },
    ],
    statements: [
      { who: "联名插画师 鹿屿", role: "当事创作者", text: "我把每一版草稿都放出来了。相似让我很被动，但我不想被扣上抄袭的帽子。" },
      { who: "品牌公关负责人", role: "第一方回应", text: "下架是稳妥选择。我们需要先把设计流程复盘清楚，再决定后续。" },
    ],
    related: ["copy-script", "mcn-contract-split"],
  },
  {
    id: "fake-romance-script",
    title: "“官宣恋情”被扒是剧本：合作方删帖，粉丝直呼上当",
    handle: "@两颗糖的日常",
    category: "剧情炒作",
    status: "事件反转",
    reversal: 4,
    follow: 27,
    updatedAt: "2026-09-06",
    readTime: "6 分钟",
    summary:
      "一对情侣博主以“官宣”冲上热搜，随后被扒出双方分属同一机构。四条时间线上的矛盾，让整件事像个被写好的剧本。",
    cover: "https://readdy.ai/api/search-image?query=Two%20theater%20masks%20and%20a%20torn%20playbill%20script%20lying%20on%20a%20dim%20stage%20floor%20under%20a%20single%20spotlight%2C%20warm%20amber%20and%20deep%20crimson%20editorial%20lighting%2C%20dark%20textured%20paper%20backdrop%2C%20cinematic%20depth%20of%20field%2C%20high%20detail%2C%20moody%20magazine%20still%20life%2C%20no%20text%2C%20no%20watermark%2C%20cohesive%20muted%20warm%20palette&width=1200&height=800&seq=gtk-case-06&orientation=landscape",
    tags: ["剧本", "官宣", "同一机构", "删帖"],
    timeline: [
      { date: "2026-08-18", type: "爆料", title: "双人“官宣”引爆热搜", desc: "两位博主同步发布合照，文案高度一致，短时间内冲上热搜榜前列。" },
      { date: "2026-08-22", type: "反转", title: "网友发现双方同属一家机构", desc: "有人扒出两人商务联系方式指向同一家公司，“偶遇”情节也被质疑为摆拍。" },
      { date: "2026-08-25", type: "反转", title: "评论区“时间线”自相矛盾", desc: "两人早期视频里的相遇时间、地点说法对不上，被整理成对比图广泛传播。" },
      { date: "2026-08-27", type: "回应", title: "合作方悄悄删除推广帖", desc: "相关品牌的推广内容陆续被删，未作公开说明，进一步引发“剧本”猜测。" },
      { date: "2026-09-06", type: "官方", title: "双方暂未正面回应", desc: "截至目前，两位博主未就“剧本”质疑给出明确答复，事件仍在发酵。" },
    ],
    statements: [
      { who: "资深内容策划 老周", role: "第三方分析", text: "情侣档是天然的高互动内容模型，一旦被发现是同机构运作，信任成本会瞬间崩塌。" },
      { who: "@两颗糖的日常", role: "当事账号", text: "我们的关系是真的，其他不便多说，请大家给点私人空间。" },
    ],
    related: ["data-traffic", "live-sell-price"],
  },
];

export const heroCase = cases[0];

export const featuredList = [cases[1], cases[5], cases[3], cases[4]];

export const rankedList = [cases[5], cases[1], cases[0], cases[3], cases[2], cases[4]];